import BillingsOrderCargoTaxiDraftRequest from "../../../../../api/raily/billings/order/cargo-taxi/draft/billings-order-cargo-taxi-draft.request";
import BillingsOrderCargoTaxiDraftParams from "./billings-order-cargo-taxi-draft-params";

const create = (
  params: BillingsOrderCargoTaxiDraftParams,
): BillingsOrderCargoTaxiDraftRequest => {
  return {
    orderUuid: params.orderUuid,
  };
};

const billingsOrderCargoTaxiDraftParamsFactory = {
  create,
};

export default billingsOrderCargoTaxiDraftParamsFactory;
